import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => navigate('/admin', { replace: true, state: { user: data } }))
      .catch((err) => navigate('/admin', { replace: true, state: { authError: err.response?.data?.detail || 'Login failed. Please try again.' } }));
  }, [location.hash, navigate]);

  return <div data-testid="auth-callback" className="min-h-screen bg-[#053e49]" />;
}
